import script from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"

import "./AchievementInfo.vue?vue&type=style&index=0&id=46229cca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46229cca"]])

export default __exports__